//@flow
//Action Type Registered
export const ORION_INV_SUBMIT_SUCCESS='ORION_INV_SUBMIT_SUCCESS'
export const ORION_INV_SUBMIT_ERROR='ORION_INV_SUBMIT_ERROR'
export const ORION_INV_SUBMITTED_COMPLETED='ORION_INV_SUBMITTED_COMPLETED'
export const ORION_EDIT_VERIFY_FORM_DATA_SUCCESS='ORION_EDIT_VERIFY_FORM_DATA_SUCCESS'
export const ORION_EDIT_VERIFY_FORM_DATA_ERROR='ORION_EDIT_VERIFY_FORM_DATA_ERROR'
export const ORION_UPDATE_FORM_ERROR='ORION_UPDATE_FORM_ERROR'
export const REFRESH_ORION_VENDORS_SUCCESS='REFRESH_ORION_VENDORS_SUCCESS'
export const REFRESH_ORION_VENDORS_ERROR='REFRESH_ORION_VENDORS_ERROR'



// WEBPACK FOOTER //
// ./src/redux/orion/actionTypes.js